import { Box, Button, Stack, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Link as RouterLink } from 'react-router-dom';
import { paths } from '@/routes/paths';

/** Inline or full-page "you don't have access" surface (spec §6, §23). */
export function PermissionDenied({ full = true }: { full?: boolean }) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ py: full ? 12 : 6, px: 2, textAlign: 'center' }}
    >
      <Box sx={{ color: 'warning.main', fontSize: 56, display: 'flex' }}>
        <LockOutlinedIcon fontSize="inherit" />
      </Box>
      <Typography variant="h5">Access denied</Typography>
      <Typography variant="body2" color="text.secondary" maxWidth={440}>
        You don&apos;t have permission to view this area. If you believe this is a mistake, contact
        an administrator.
      </Typography>
      {full && (
        <Button component={RouterLink} to={paths.dashboard} variant="contained">
          Back to dashboard
        </Button>
      )}
    </Stack>
  );
}
